import { AccordionBodyDeprecated, AccordionLabelDeprecated } from 'ui/accordion';
import { localize } from 'utils/numberHelpers';
import { ARROW_DIRECTION_DOWN, ARROW_DIRECTION_UP } from 'ui/collapsibleContent';
import {
  BreakdownAccordionPlain,
  StyledReasons,
  AccordionLabelRow,
  AccordionBodyRow,
  MetricList,
} from './Styled';

export const SendSkipBreakdown = ({ bucket, reasonPrefix }) => {
  return (
    <MetricList>
      <BreakdownAccordionPlain>
        <AccordionLabelDeprecated
          arrowHeight={16}
          arrowWidth={16}
          arrowStart={ARROW_DIRECTION_DOWN}
          arrowEnd={ARROW_DIRECTION_UP}
        >
          <AccordionLabelRow>
            <span>
              {bucket.count.toLocaleString()} {reasonPrefix} send skips
            </span>
            <StyledReasons>{Object.keys(bucket.data || {}).length} reasons</StyledReasons>
          </AccordionLabelRow>
        </AccordionLabelDeprecated>
        <AccordionBodyDeprecated>
          {Object.keys(bucket.data || {}).map((key) => (
            <AccordionBodyRow key={key}>
              <span>{key}</span>
              <span>{localize(bucket.data?.[key])}</span>
            </AccordionBodyRow>
          ))}
        </AccordionBodyDeprecated>
      </BreakdownAccordionPlain>
    </MetricList>
  );
};
